import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

import { ModalContents } from './ModalContents';

interface ModalProps {
  closeModal: () => void;
  detailedNoticeModalVisible: boolean;
  detailedNoticeData: any;
  //setApartmentListData: Dispatch<SetStateAction<any[]>>;
}

export const Modal = ({
  closeModal,
  detailedNoticeModalVisible,
  detailedNoticeData,
}: ModalProps) => {
  return (
    <Background onClick={closeModal}>
      <Container
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <ModalContents
          closeModal={closeModal}
          detailedNoticeData={detailedNoticeData}
        />
      </Container>
    </Background>
  );
};

const Background = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* rgba(0, 0, 0, 0.3) */
  z-index: 999;
`;

const Container = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: white;

  @media (max-width: 900px) {
    margin: 20px;
  }
`;
